import React from 'react';
import styled from 'styled-components';

import {labels} from '../../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/motif-react-wrapper/Icon';
import {MotifAlertIcErrorOutline24px} from '@ey-xd/motif-icon';

export const config = ({
	id,
	fullId = null,
	label,
	prop,
	isOverdue = null, // function that requires item
	width = 'minmax(var(--px-170), 1fr)'
}) => ({
	id: fullId ? fullId : `${id}YesNoOverdueColumn`,
	label,
	propName: prop,
	sortBy: prop,
	width,
	customCell: (item) => (
		<StyledTextWithOverdueIcon body2 light>
			{item[prop] ? labels.yes : labels.no}
			{isOverdue && isOverdue(item) && <Icon title={labels.overdueLabel} src={MotifAlertIcErrorOutline24px} />}
		</StyledTextWithOverdueIcon>
	)
});

export const StyledTextWithOverdueIcon = styled(OutputText)`
	display: flex;
	gap: var(--spacing-x-small);
	align-items: center;
	.motif-icon {
		--size: var(--px-20);
		color: var(--red-500);
		height: var(--size);
	}
`;
